module.exports = __webpack_public_path__ + "static/img/head-pic@2x.7678abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/head-pic@2x.png
// module id = 47nT
// module chunks = 1